import {ChangeDetectionStrategy, Component, input} from '@angular/core'
import {BrandingModule} from '../../../branding/branding.module'
import {PipesModule} from '../../../../pipes/pipes.module'
import {SupportBoxModule} from '../../../../../craft/support/support-box/support-box.module'
import {SupportPortraitComponent} from '../../../../../craft/support/support-portrait/support-portrait.component'
import {TranslocoDirective} from '@ngneat/transloco'
import {NgOptimizedImage} from '@angular/common'
import {FaIconComponent} from '@fortawesome/angular-fontawesome'
import {faPhone} from '@fortawesome/pro-solid-svg-icons/faPhone'
import {faChevronRight} from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import {PhoneNumberMaskPipe} from '../../../../pipes/phone-number-mask.pipe'
import {ContactModalComponent} from './contact-modal.component'
import {DialogService} from '../../../../../craft/dialog/dialog.service'
import {faEnvelope} from '@fortawesome/pro-solid-svg-icons/faEnvelope'
import {AgencyLogoComponent} from './agency-logo/agency-logo.component'

export type Agent = {
  firstName: string
  lastName: string
  email?: string | undefined
  phoneNumber?: string | undefined
}

export type Agency = {
  name?: string
}

export type Logo = {
  title?: string
  url: string
}

@Component({
  selector: 'bgo-job-agent-support-box',
  standalone: true,
  imports: [
    BrandingModule,
    PipesModule,
    SupportBoxModule,
    TranslocoDirective,
    NgOptimizedImage,
    SupportPortraitComponent,
    FaIconComponent,
    PhoneNumberMaskPipe,
    AgencyLogoComponent,
  ],
  templateUrl: './job-agent-support-box.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    @reference "../../../../../../styles/app-reference.css";
    :host {
      @apply block rounded-3 px-md py-sm shadow-1;
    }
  `,
})
export class JobAgentSupportBoxComponent {
  agent = input.required<Agent>()
  agency = input<Agency | undefined>()
  logo = input<Logo>()
  damageCaseNumber = input<string>()
  protected readonly faPhone = faPhone
  protected readonly faEmail = faEnvelope
  protected readonly faChevronRight = faChevronRight

  constructor(private readonly dialogService: DialogService) {}

  showContactDialog(e: MouseEvent) {
    e.stopPropagation()
    const agent = this.agent()
    this.dialogService.show(ContactModalComponent, {email: agent.email, phoneNumber: agent.phoneNumber})
  }
}
